import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/allowance")({
  beforeLoad: () => {
    throw redirect({ to: "/activities", replace: true });
  },
});
